import React from "react";
import { Heart, Facebook, Linkedin, Instagram, Youtube } from "lucide-react";
import logo from "../assets/logo-circle-only.png";

const Footer = ({ scrollTo }) => {
  const socialLinks = [
    {
      Icon: Facebook,
      url: "https://www.facebook.com/profile.php?id=61585379175254",
      label: "Facebook",
    },
    {
      Icon: Linkedin,
      url: "https://www.linkedin.com/in/indoglobusexim",
      label: "LinkedIn",
    },
    {
      Icon: Instagram,
      url: "https://www.instagram.com/indoglobus?igsh=MTB4MmR2cG56OHpkMA==",
      label: "Instagram",
    },
    {
      Icon: Youtube,
      url: "https://www.youtube.com/@IndoGlobus",
      label: "YouTube",
    },
  ];

  return (
    <footer className="bg-white text-slate-900 py-12 md:py-16 border-t border-slate-100 font-sans">
      <div className="container mx-auto px-4 text-center md:text-left">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mb-12">
          {/* Brand Identity */}
          <div className="space-y-4 md:space-y-5">
            <div className="flex items-center justify-center md:justify-start gap-3">
              <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center shadow-lg overflow-hidden border-2 border-slate-50">
                <img
                  src={logo}
                  alt="Indo Globus Symbol"
                  className="h-full w-full object-contain scale-90"
                />
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-bold text-primary tracking-tight font-display uppercase">
                  IndoGlobus
                </h3>
                <p className="text-[10px] md:text-xs text-slate-500 font-bold uppercase tracking-wider">
                  Connecting The World
                </p>
              </div>
            </div>
            <p className="text-sm md:text-base text-slate-600 leading-relaxed max-w-sm mx-auto md:mx-0">
              Premium organic dehydrated powders and high-quality
              agro-commodities for the global market.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="hidden sm:block">
            <h4 className="font-display font-bold text-base md:text-lg mb-6 text-primary uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3 text-slate-600">
              {["Home", "About", "Products", "Contact"].map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollTo(link.toLowerCase())}
                    className="hover:text-accent transition-colors font-medium uppercase text-xs tracking-widest"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Presence */}
          <div className="space-y-6">
            <h4 className="font-display font-bold text-base md:text-lg mb-6 text-primary uppercase tracking-wider">
              Connect With Us
            </h4>
            <div className="flex justify-center md:justify-start gap-4">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="h-10 w-10 md:h-12 md:w-12 rounded-full bg-slate-100 flex items-center justify-center text-primary hover:bg-primary hover:text-accent transition-all duration-300 shadow-sm border border-slate-200"
                >
                  <social.Icon size={20} />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-100 pt-8 text-center">
          <p className="text-slate-400 font-bold text-[10px] uppercase tracking-widest flex items-center justify-center gap-2">
            © 2025 IndoGlobus. Built with{" "}
            <Heart
              size={14}
              className="text-red-500 fill-red-500 animate-pulse"
            />{" "}
            in India.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
